export const bannerTextContainerClasses = 'h-fit rounded bg-action p-1 text-xs font-medium text-surface sm:mt-0';
